<template>
  <div class="min-h-screen flex items-center justify-center bg-background px-6">
    <div class="w-full max-w-lg bg-card border rounded-xl shadow-sm p-6">
      <div class="text-2xl font-bold mb-2">Acesso não autorizado</div>
      <p class="text-muted-foreground mb-4">
        Você não tem autorização para acessar esta página.
      </p>

      <div class="text-sm text-muted-foreground space-y-2">
        <div>Entre em contato com o administrador do sistema para obter autorização.</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnauthorizedView',
}
</script>

